module.exports = __webpack_public_path__ + "portal-static/img/banner.5cbb3b51.png";